import request from "@/utils/request";

export function getReqRecord(query) {
  return request({
    url: "/api/stat/record/req-record",
    method: "post",
    data: query
  });
}

export function getRecordDetail(docId, date) {
  return request({
    url: "/api/stat/record/req-record-detail?docId=" + docId + "&date=" + date,
    method: "get"
  });
}

export function getReqStat(startTime, endTime, categoryName) {
  return request({
    url: "/api/stat/record/req-stat",
    method: "post",
    data: {
      startTime,
      endTime,
      categoryName
    }
  });
}

export function getCostStat() {
  return request({
    url: "/api/stat/record/cost-stat",
    method: "get"
  });
}

// 按日期获取商户调用明细
export function getMerchantTimeData(query) {
  return request({
    url: "/api/stat/recordv2/details",
    method: "get",
    params: query
  });
}
//  按日期导出商户调用明细
export function exportMerchantTiemDetail(query) {
  return request({
    url: "/api/stat/recordv2/export/details",
    method: "get",
    params: query
  });
}
// 按接口获取商户调用明细
export function getMerchantApiData(query) {
  return request({
    url: "/api/stat/recordv2/details-by-category",
    method: "get",
    params: query
  });
}
// 按接口导出商户调用明细
export function exportMerchantApiDetail(query) {
  return request({
    url: "/api/stat/recordv2/export/details-by-category",
    method: "get",
    params: query
  });
}



// WEBPACK FOOTER //
// ./src/services/board.js